import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

type LinkMap = {
  [key: string]: string;
  en: string;
};

type CountryAndWoltPlusLink = {
  country: Country;
  link: LinkMap;
};

const WOLT_PLUS_BANNER_COUNTRIES_CONFIGS: CountryAndWoltPlusLink[] = [
  {
    country: 'NOR',
    link: {
      en: 'https://forms.monday.com/forms/06b1971d7828d6cdfb78bb1822321161?r=use1',
      no: 'https://forms.monday.com/forms/b36e71f3a30dad3667be791d7d9b7d35?r=use1',
    },
  },
  {
    country: 'SVK',
    link: {
      en: 'https://forms.monday.com/forms/de0103753922c2af8846ec8b932b9053?r=use1',
      sk: 'https://forms.monday.com/forms/5c12fbe5bb558456838d254ed583a916?r=use1',
    },
  },
  {
    country: 'CZE',
    link: {
      en: 'https://forms.monday.com/forms/3a0be9cf00218e730b6fec57a3b5afd0?r=use1',
      cs: 'https://forms.monday.com/forms/d51dc9f36bea169f501359bb2bd167c6?r=use1',
    },
  },
];

const WOLT_PLUS_BANNER_COUNTRIES = WOLT_PLUS_BANNER_COUNTRIES_CONFIGS.map(entry => entry.country);

export const shouldDisplayWoltPlusBanner = ({ country, isWoltPlus }: { country?: Country; isWoltPlus?: boolean }) => {
  return !!country && WOLT_PLUS_BANNER_COUNTRIES.includes(country) && !isWoltPlus;
};

export const reportBannerClick = (action: 'TELL_ME_MORE' | 'DISMISS') => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', {
    hitType: 'event',
    eventCategory: 'WOLT_PLUS',
    eventAction: action,
  });
};

export const getWoltPlusBannerLink = (country: Country, language: string): string => {
  const woltPlusCountryConfig = WOLT_PLUS_BANNER_COUNTRIES_CONFIGS.find(config => config.country === country);
  if (!woltPlusCountryConfig) {
    return '';
  }

  const linkLanguage = language in woltPlusCountryConfig.link ? language : 'en';
  return woltPlusCountryConfig.link[linkLanguage];
};
